import {
  NoWhenBranchMatchedException3krrgsc7u48pz as NoWhenBranchMatchedException,
  NullPointerException3mu0rhxjjitqq as NullPointerException,
  ClassCastException1atiay3nqgbd as ClassCastException,
} from './exceptions.mjs';
import { KotlinNothingValueException2zr0cdstak0a9 as KotlinNothingValueException } from './ExceptionsH.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function noWhenBranchMatchedException() {
  throw NoWhenBranchMatchedException().new_kotlin_NoWhenBranchMatchedException_9ooqm1_k$();
}
function THROW_NPE() {
  throw NullPointerException().new_kotlin_NullPointerException_q6jd54_k$();
}
function THROW_CCE() {
  throw ClassCastException().new_kotlin_ClassCastException_zhuhe1_k$();
}
function throwKotlinNothingValueException() {
  throw KotlinNothingValueException().new_kotlin_KotlinNothingValueException_56qecr_k$();
}
function ensureNotNull(v) {
  var tmp;
  if (v == null) {
    THROW_NPE();
  } else {
    tmp = v;
  }
  return tmp;
}
//region block: exports
export {
  THROW_CCE as THROW_CCE2g6jy02ryeudk,
  ensureNotNull as ensureNotNull1e947j3ixpazm,
  noWhenBranchMatchedException as noWhenBranchMatchedException2a6r7ubxgky5j,
  throwKotlinNothingValueException as throwKotlinNothingValueException2lxmvl03dor6f,
};
//endregion

//# sourceMappingURL=hacks.mjs.map
